import { colors, text, sx } from '../design/tokens'
import { ANCHO_DEPOSITO } from '../utils/stockPresea'

// Stock EN VIVO de Presea al cargar artículos (NV nueva, edición de NV y
// presupuesto). Única regla de cómo se pinta: una columna por depósito, en el
// orden en que los manda Presea, con la referencia UNA vez en la cabecera
// (Martin, 3 sep 2026). "?" = renglón agregado después de consultar, "—" =
// Presea no conoce el código, rojo = no alcanza para la cantidad. Lo que
// alcanza lo decide el backend (`disponible`: 100 + 400 + 401, sug #90).

const grilla = (n) => ({ display: 'inline-grid', gridTemplateColumns: `repeat(${Math.max(1, n)}, ${ANCHO_DEPOSITO}px)`, textAlign: 'right' })
const s = {
  ref: { ...sx.mono, fontSize: 9.5, fontWeight: 400, color: colors.textMeta, letterSpacing: 0, textTransform: 'none', marginTop: 2 },
  num: { ...sx.mono, fontSize: text.sec, fontWeight: 600, fontVariantNumeric: 'tabular-nums' },
  cero: { color: colors.textMeta, fontWeight: 400 },
  falta: { color: colors.errStrong, fontWeight: 700 },
}

// Contenido del <th>: "Stock" + los números de depósito alineados con la celda.
export function CabeceraStockPresea({ depositos }) {
  return (
    <>
      <div>Stock</div>
      <div style={grilla(depositos.length)}>
        {depositos.map(d => <span key={d} style={s.ref}>{d}</span>)}
      </div>
    </>
  )
}

export default function CeldaStockPresea({ porCodigo, depositos, codigo, cantidad, style }) {
  if (!codigo) return <td style={{ ...style, color: colors.textMeta }} title="Concepto libre: no tiene stock">—</td>
  const stk = porCodigo[codigo]
  if (stk === undefined) {
    return <td style={{ ...style, color: colors.textMeta }} title="Agregado después de la consulta — volvé a apretar Consultar stock">?</td>
  }
  if (stk === null) {
    return <td style={{ ...style, color: colors.textMeta }} title="Presea no conoce este código">—</td>
  }
  const disponible = stk.disponible ?? (stk.depo100 + stk.depo400)
  const falta = disponible < (parseFloat(cantidad) || 0)
  return (
    <td style={{ ...style, whiteSpace: 'nowrap', textAlign: 'left' }}
      title={depositos.map(d => `Depósito ${d}: ${stk.depositos?.[d] ?? 0}`).join(' · ') + ` — disponible para vender: ${disponible}` + (falta ? ' — NO ALCANZA' : '')}>
      <div style={grilla(depositos.length)}>
        {depositos.map(d => {
          const n = stk.depositos?.[d] ?? 0
          return (
            <span key={d} style={{ ...s.num, ...(n === 0 ? s.cero : {}), ...(falta && n > 0 ? s.falta : {}) }}>
              {n}
            </span>
          )
        })}
      </div>
    </td>
  )
}
